import React, { useState, useEffect } from 'react';

const WORDS = ["Brands", "Experts", "Ideas", "Transformations"];
const TYPING_SPEED = 150;
const DELETING_SPEED = 75;
const PAUSE_DURATION = 2000;

function CreateBrands({ setView }) {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timer;
    const targetWord = WORDS[currentWordIndex];

    if (!isDeleting) {
      if (currentText.length < targetWord.length) {
        timer = setTimeout(() => {
          setCurrentText(targetWord.substring(0, currentText.length + 1));
        }, TYPING_SPEED);
      } else {
        timer = setTimeout(() => {
          setIsDeleting(true);
        }, PAUSE_DURATION);
      }
    } else {
      if (currentText.length > 0) {
        timer = setTimeout(() => {
          setCurrentText(targetWord.substring(0, currentText.length - 1));
        }, DELETING_SPEED);
      } else {
        setIsDeleting(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % WORDS.length);
      }
    }

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentWordIndex]);

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="create-brands-section">
      <div className="container create-brands-container">
        
        {/* Left Column: Typewriter Content */}
        <div className="create-brands-left">
          <h2 className="create-brands-title">
            Here We Create <span className="create-brands-typed">{currentText}</span>
            <span className="create-brands-cursor">|</span>
          </h2>
          
          <p className="create-brands-desc">
            At Experts Communication, our mission is to help your business grow from every angle. As a trusted BPO partner, we apply our knowledge and skills in the smartest way to deliver meaningful results. Alongside this, our IT team ensures you can work with complete peace of mind by offering dependable software solutions and robust security systems—allowing you to focus your energy on what truly matters.
          </p>

          <button className="btn-schedule btn-create-brands-cta" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Jobs Collage Image */}
        <div className="create-brands-right">
          <img 
            src="/assets/images/jobs_collage.png" 
            alt="Jobs Collage Mockup" 
            className="create-brands-img"
          />
        </div>

      </div>
    </section>
  );
}

export default CreateBrands;
